import BenefitsPanel, { BenefitsCardContentProps } from "@components/BenefitsPanel";
import React from "react";

interface GetStartedSectionProps {
    variant?: "light" | "blue";
}

const BenefitsCardContent: BenefitsCardContentProps[] = [
    {
        imageUrl: "/contact/one-on-one-demo.svg",
        title: "1-on-1 Demos",
        description: "Discuss with our product experts and understand how Gallabox can be tailored for your business use case.",
    },
    {
        imageUrl: "/contact/star-circle.svg",
        title: "Experience all features",
        description: "Try out Gallabox's amazing features at no cost. Try our free trial and see how Gallabox can revolutionize your business.",
    },
    {
        imageUrl: "/contact/demo.svg",
        title: "Custom demos for teams",
        description: "Gallabox caters to all stages of the customer journey. Our demo can be customized to address your specific marketing, sales, and support goals.",
    },
];

const GetStartedSection: React.FC<GetStartedSectionProps> = ({ variant = "light" }) => {
    const isBlue = variant === "blue";

    const sectionClasses = isBlue ? "py-16 px-4 lg:gap-8 gap-6 items-start" : "lg:my-20 lg:mx-auto mx-2 my-10 flex flex-col lg:gap-8 gap-6";

    const titleClasses = isBlue ? "text-3xl text-white font-bold" : "text-3xl text-gray-700 font-bold text-start";

    const buttonClasses = isBlue
        ? "w-fit px-6 py-2.5 text-lg font-bold text-blue-500 rounded-lg hover:no-underline focus:outline-none hover:shadow-lg bg-white hover:bg-gray-50 transition duration-300 ease-in-out"
        : "w-fit px-6 py-2.5 text-lg font-bold text-white rounded-lg hover:no-underline focus:outline-none hover:shadow-lg bg-blue-500 hover:bg-blue-600 transition duration-300 ease-in-out";

    const buttonWrapperClasses = "flex justify-center lg:justify-end max-w-6xl mx-auto w-full px-4 mt-8";

    return (
        <section className={`${sectionClasses} mb-20 py-20`} style={{ backgroundColor: isBlue ? "#3364FA" : "#DDEBFF" }}>
            <BenefitsPanel mainTitle={<h2 className={titleClasses}>Get started today and unlock 🔓</h2>} cardContent={BenefitsCardContent} variant={variant} />
            <div className={buttonWrapperClasses}>
                <a href="https://app.gallabox.com/signup" target="_blank" rel="noreferrer" className={buttonClasses}>
                    Start free trial
                </a>
            </div>
        </section>
    );
};

export default GetStartedSection;
